import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
  const { resource } = route.meta || {}
  const action = route.meta.action || 'read'

  // Handle array of resources
  if (Array.isArray(resource)) {
    return resource.some(res => ability.can(action, res))
  }

  // Handle single resource string
  return ability.can(action, resource)
})

export const _ = undefined
